module.exports = __webpack_public_path__ + "static/media/cheese2.88b7e383.png";